import { NavLink } from 'react-router-dom';
import { useTravelTranslation } from '../../app/TravelLocaleContext';

/** Relationship-feed switch for Following page（Explore IA v2）。 */
export default function SocialFeedSwitch() {
  const { t } = useTravelTranslation();
  return (
    <nav className="social-feed-switch social-feed-switch--secondary" aria-label={t('travel.discover.posts.followingHint')}>
      <NavLink to="/explore" data-testid="feed-switch-posts">
        {t('travel.discover.tabs.forYou')}
      </NavLink>
      <NavLink to="/social/following" data-testid="feed-switch-following">
        {t('travel.discover.posts.following')}
      </NavLink>
    </nav>
  );
}
